import { createContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading]=useState(true)
  const navigate=useNavigate()

  useEffect(() => {
    const storedToken = localStorage.getItem("token");
    if (storedToken) {
      //Decode the token
      const decodedUser=jwtDecode(storedToken)
      //Check token expiration
      const currentTime = Math.floor(Date.now() / 1000);
    if (decodedUser.exp < currentTime) {
      localStorage.removeItem("token");
      window.location.href = "/login";
      return;
    }
      setUser(decodedUser);
      setLoading(false)
    }else{setLoading(false)}
  }, []);

  const login = (userToken) => {
    localStorage.setItem("token", JSON.stringify(userToken));
    const decodedUser=jwtDecode(userToken)
    setUser(decodedUser);
    setLoading(false)
  };

  const logout = () => {
    setUser(null)
    localStorage.removeItem("token");
    sessionStorage.clear()
    navigate("/login")
  };
  return (
    <AuthContext.Provider value={{ user, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};
